// redux/reducers/makeReducer.js

  const initialState = {
    loading: false,
    newPass: false,
    error: false,
    makeListing:[],
    makeDetail:null
  };
  
  const makeReducer = (state = initialState, action) => {
    console.log("make reducers------", state,action);
   switch (action.type) {
     case "ADD_MAKE_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_MAKE_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_MAKE_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_MAKE_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_MAKE_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_MAKE_REQUEST_SUCCESS":
        return {
          ...state,
          makeListing: action.payload,
          loading:false,
        };

      case "GOT_MAKE_DETAIL":  
      return {
        ...state,
        makeDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default makeReducer;
  